'use client';

import React from 'react';
import { IdView } from '../../../../components';
import { RevshareBill } from '../types';

interface IdCellProps {
  bill: RevshareBill;
}

const IdCell: React.FC<IdCellProps> = ({ bill }) => {
  // Show last 4 digits of company_id, copy full _id
  const displayId = bill._id.slice(-4);
  const copyId = bill._id;

  return (
    <div className="flex items-center">
      <IdView textToCopy={copyId}>{displayId}</IdView>
    </div>
  );
};

export default IdCell;
